import classNames, { ArgumentArray } from "classnames";
import { extendTailwindMerge } from "tailwind-merge";

import tokens from "@/components/ui/tokens";

const { extend } = tokens.theme;

// tailwind-merge does not read tailwind.config.js, so it has to be told the token names. Without this,
// it reads `text-ds-header-subheader` as a color and drops it next to `text-ds-text-primary`.
// https://github.com/dcastil/tailwind-merge/blob/v2.6.0/docs/configuration.md#usage-with-custom-tailwind-config
const twMerge = extendTailwindMerge<"ds-text-style">({
  extend: {
    theme: { spacing: Object.keys(extend.spacing) },
    classGroups: {
      "font-size": [{ text: Object.keys(extend.fontSize) }],
      rounded: [{ rounded: Object.keys(extend.borderRadius) }],
      size: [{ size: Object.keys(extend.size) }],
      shadow: [{ shadow: Object.keys(extend.boxShadow) }],
      "backdrop-blur": [{ "backdrop-blur": Object.keys(extend.backdropBlur) }],
      // Text style classes (ds-header-h1): the last one wins. They do not conflict with font-size or
      // font-weight, so `cn("ds-body-base-regular", "font-semibold")` keeps both.
      "ds-text-style": tokens.textStyles,
    },
  },
});

export function cn(...inputs: ArgumentArray) {
  return twMerge(classNames(inputs));
}
